// Bulk email parsing for the permissions grant form. The textarea accepts one or
// many emails separated by commas, whitespace, and/or newlines; we split, trim,
// lowercase, de-dupe, and split the tokens into valid vs. invalid so the form can
// preview the batch and refuse to submit malformed input.

// Deliberately pragmatic (not RFC 5322): a non-empty local part, an @, a dotted
// domain. Good enough to catch fat-finger mistakes without rejecting real addresses.
const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export interface ParsedEmails {
  /** Unique, lowercased, valid addresses in first-seen order. */
  valid: string[];
  /** Tokens that didn't look like an email (original casing, de-duped). */
  invalid: string[];
}

export function parseEmailList(raw: string): ParsedEmails {
  const tokens = raw
    .split(/[\s,;]+/)
    .map((t) => t.trim())
    .filter((t) => t.length > 0);

  const valid: string[] = [];
  const invalid: string[] = [];
  const seenValid = new Set<string>();
  const seenInvalid = new Set<string>();

  for (const token of tokens) {
    if (EMAIL_RE.test(token)) {
      const normalized = token.toLowerCase();
      if (!seenValid.has(normalized)) {
        seenValid.add(normalized);
        valid.push(normalized);
      }
    } else if (!seenInvalid.has(token)) {
      seenInvalid.add(token);
      invalid.push(token);
    }
  }

  return { valid, invalid };
}
